module.exports = __webpack_public_path__ + "media/brunner.cd4e8516.wav";